export default {
	getMenu(shopid, cb) {
		//shopid暂时没用 - 这里目前是获取全部商品分类
		this.http.get('/shop/cashiermenu4/', {}).then((response) => {
			cb(response)
		})
	},
	getShopMenu(shopid, cb) {
		//门店专属菜单
		this.http.get(`/shop/getMenuByShop/${shopid}`, {}).then((response) => {
			cb(response)
		})
	},
	getShopMenuList(shopid, cb) {
		//获取全部门店专属菜单
		this.http.get(`/shop/getMenusByShop/${shopid}`, {}).then((response) => {
			cb(response)
		})
	},
	getDiyCategory(shopid, id, cb, ecb) {
		this.http
			.get(`/shop/getDiyCategory/${shopid}/${id}`, {})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getItemsByTag(shopid, tag, cb) {
		this.http.get(`/shop/getItemsByTag/${shopid}/${tag}`, {}).then((r) => {
			cb(r)
		})
	},
	getCategory(id, cb) {
		this.http.get('/shop/getCategory/' + id, {}).then((response) => {
			cb(response)
		})
	},
	createOrder(form, cb, ecb) {
		this.http
			.post('/shop/createOrder/', form)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	}
}
